import { useEffect } from "react";
import isEditable from "./isEditable.js";

export default function useTicketListKeyboard({ enabled, length, highlightedIndex, setHighlightedIndex, onOpen, onSearch }) {
    useEffect(() => {
        if (!enabled) return;
        const handler = (e) => {
            if (e.metaKey || e.ctrlKey || e.altKey) return;
            if (e.key === "/" && !isEditable(e.target)) {
                e.preventDefault();
                onSearch?.();
                return;
            }
            if (e.key === "Escape" && isEditable(e.target) && e.target.tagName === "INPUT") {
                e.target.blur();
                return;
            }
            if (isEditable(e.target)) return;
            const k = e.key.toLowerCase();
            if (k === "j") {
                e.preventDefault();
                setHighlightedIndex((i) => Math.min((i ?? -1) + 1, Math.max(0, length - 1)));
            } else if (k === "k") {
                e.preventDefault();
                setHighlightedIndex((i) => Math.max((i ?? 0) - 1, 0));
            } else if (e.key === "Enter") {
                if (highlightedIndex == null || highlightedIndex < 0 || highlightedIndex >= length) return;
                e.preventDefault();
                onOpen?.(highlightedIndex);
            }
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [enabled, length, highlightedIndex, setHighlightedIndex, onOpen, onSearch]);
}
